var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[_c('el-steps',{attrs:{"active":_vm.$store.getters.demAct,"simple":""}},[_c('el-step',{attrs:{"title":"上传模型"}}),_c('el-step',{attrs:{"title":"选择打印机"}}),_c('el-step',{attrs:{"title":"选择耗材"}}),_c('el-step',{attrs:{"title":"选择物流"}}),_c('el-step',{attrs:{"title":"交付方案"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }